export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const units = ['KiB', 'MiB', 'GiB'];
  let value = bytes / 1024;
  let index = 0;
  while (value >= 1024 && index < units.length - 1) {
    value /= 1024;
    index += 1;
  }
  return `${value.toFixed(value >= 10 ? 1 : 2)} ${units[index]}`;
}

export function formatSizeChange(sourceBytes: number, outputBytes: number): string {
  if (sourceBytes <= 0) return 'Size change unavailable';
  const change = ((outputBytes - sourceBytes) / sourceBytes) * 100;
  if (Math.abs(change) < 0.05) return 'No size change';
  return `${Math.abs(change).toFixed(1)}% ${change < 0 ? 'smaller' : 'larger'}`;
}
